import React, { useEffect, useRef, useState } from "react";
import search_svg from "../../assets/images/svg/search.svg";
import closeInput from "../../assets/images/svg/closeInput.svg";

const SearchButton = ({
  search,
  setSearch,
  width,
  handleRef,
  type,
  className = "",
  ariaLabel = "Search",
}) => {
  const buttonRef1 = useRef(null);
  const imgRef1 = useRef(null);
  const imgRef2 = useRef(null);
  const searchButtonRef = useRef(null);
  const [isTab, setIsTab] = useState(false);
  const [isButton, setIsButton] = useState(true);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const handleClick = (e) => {
    setIsButtonClicked(true);
    buttonRef1.current.focus();
    buttonRef1.current.style.width = width;
    setTimeout(() => {
      imgRef1.current.style.display = "block";
    }, 300);

    imgRef2.current.style.left = "27px";
    buttonRef1.current.style.paddingLeft = "58px";
    buttonRef1.current.style.paddingRight = "46px";
    searchButtonRef.current.style.display = "none";

    buttonRef1.current.focus();
    type !== undefined && handleRef("hide");
  };
  const handleClose = () => {
    setIsButtonClicked(false);
    setSearch("");
    buttonRef1.current.style.width = isTab ? "42px" : "48px";
    imgRef2.current.style.left = isTab ? "14px" : "16px";
    buttonRef1.current.style.paddingLeft = "16px";
    buttonRef1.current.style.paddingRight = "16px";
    imgRef1.current.style.display = "none";
    setTimeout(() => {
      searchButtonRef.current.style.display = "flex";
    }, 300);

    type !== undefined && handleRef("show");
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    if (isButtonClicked) {
      setIsButton(false);
    } else {
      setIsButton(true);
    }
  }, [isButtonClicked]);

  useEffect(() => {
    !isButton && buttonRef1.current.focus();
  }, [isButton]);

  useEffect(() => {
    if (
      document.documentElement.clientWidth < 1194 &&
      document.documentElement.clientWidth > 768
    ) {
      setIsTab(true);
    }
    // eslint-disable-next-line
  }, [document.documentElement.clientWidth]);

  // useEffect(() => {
  // const btnElement = buttonRef1.current;
  //  btnElement.addEventListener("keydown", handleClick);
  //btnElement.addEventListener("keydown", handleEscapeKeyPress);
  // modalRef.current.focus();

  // return () => {
  //  btnElement.removeEventListener("keydown", handleClick);
  //  btnElement.removeEventListener("keydown", handleEscapeKeyPress);
  // };
  // }, []);

  return (
    <div className={`search_btn_out ${className}`}>
      <img
        ref={imgRef2}
        className="search_icon_btn clickable"
        src={search_svg}
        alt=""
        onClick={(e) => handleClick(e)}
      />
      <input
        id="search-instrument"
        value={search}
        ref={buttonRef1}
        onChange={handleChange}
        // onClick={(e) => handleClick(e)}
        className="search_button"
        type={"text"}
        aria-label={ariaLabel}
        aria-hidden={isButton}
        tabIndex={isButton ? -1 : 0}
      />
      <button
        ref={searchButtonRef}
        aria-label="Search"
        //  style={{ display: isButton ? "flex" : "none" }}
        className="search-actual-button outlined"
        onClick={(e) => handleClick(e)}
      >
        <img src={search_svg} alt="" />
      </button>
      <button
        aria-label="Close Search"
        className="close_btn_input clickable"
        ref={imgRef1}
        onClick={handleClose}
      >
        {" "}
        <img
          className=""
          src={closeInput}
          alt="close"
          //
        />
      </button>
    </div>
  );
};

export default SearchButton;
